import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50596119"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex justify-content-end",
    "data-kt-customer-table-toolbar": "base"
  })
], -1))
const _hoisted_6 = { class: "card-body pt-0 compact-table" }
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_9 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_10 = { class: "d-flex align-items-center flex-nowrap" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "svg-icon svg-icon-3" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "svg-icon svg-icon-3" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PropertiesAdvancedSearch = _resolveComponent("PropertiesAdvancedSearch")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'auctions'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_PropertiesAdvancedSearch, {
                onTypeSelected: _ctx.onTypeChange,
                onReset: _ctx.onReset
              }, null, 8, ["onTypeSelected", "onReset"])
            ])
          ]),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(property.id), 1)
            ]),
            "cell-propertyId": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(property.propertyId), 1)
            ]),
            "cell-block": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(property.block), 1)
            ]),
            "cell-plot": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(property.plot), 1)
            ]),
            "cell-paciNo": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(property.paciNo), 1)
            ]),
            "cell-street": _withCtx(({ row: property }) => [
              _createElementVNode("span", {
                class: "truncatable-cell",
                title: property.street,
                dir: "auto"
              }, _toDisplayString(property.street), 9, _hoisted_7)
            ]),
            "cell-houseNo": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(property.houseNo), 1)
            ]),
            "cell-size": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(property.size) + " m² ", 1)
            ]),
            "cell-startingPrice": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(_ctx.formatCurrency(property.startingPrice)), 1)
            ]),
            "cell-startingPricePerSqrM": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(_ctx.formatCurrency(property.startingPricePerSqrM)), 1)
            ]),
            "cell-salePrice": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(_ctx.formatCurrency(property.salePrice)), 1)
            ]),
            "cell-salePricePerSqrM": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(_ctx.formatCurrency(property.salePricePerSqrM)), 1)
            ]),
            "cell-paidPercentage": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(property.paidPercentage) + "% ", 1)
            ]),
            "cell-percentagePremiumPaid": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(property.percentagePremiumPaid) + "% ", 1)
            ]),
            "cell-isActive": _withCtx(({ row: property }) => [
              (property.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-createdAt": _withCtx(({ row: property }) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(property.createdAt)), 1)
            ]),
            "cell-actions": _withCtx(({ row: property }) => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                  onClick: _withModifiers(($event: any) => (_ctx.viewPropertyOverview(property.encryptedId)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                  ])
                ], 8, _hoisted_11),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                  onClick: _withModifiers(($event: any) => (_ctx.updateProperty(property.encryptedId)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen061.svg" })
                  ])
                ], 8, _hoisted_13),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                  onClick: _withModifiers(($event: any) => (_ctx.editSeo(property.id)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_16, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen064.svg" })
                  ])
                ], 8, _hoisted_15)
              ])
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}